import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const ModalContent = styled.p`
    padding: 36px 0 24px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    margin: 0;
`;

export const HeaderTitle = styled(FlexRow)`
    width: 100%;
    box-sizing: border-box;
    align-items: center;
    gap: 8px;
`;

export const ButtonGroup = styled(FlexRow)`
    box-sizing: border-box;
    gap: 4px;
    justify-content: end;
    width: 100%;
`;

export const TooltipWrapper = styled.div`
    margin-left: 4px;
`;

export const CheckWrapper = styled(FlexRow)`
    align-items: center;
`;

export const TextWrapper = styled.p`
    margin: 0;
    padding-bottom: 16px;
`;
